export default {"src":"/_next/static/media/calameo.b27dcbf6.svg","height":243,"width":243,"blurWidth":0,"blurHeight":0};